import metadata from 'libphonenumber-js/metadata.max.json';

/**
 * Shared phone change handler to satisfy architectural requirements
 * and provide consistent validation logic across forms.
 */
export const handlePhoneChange = (value, countryData, e, formattedValue, formik, fieldName) => {
    const dialCode = countryData.dialCode;
    const iso2 = (countryData.countryCode || 'IN').toUpperCase();

    // Get max length from metadata
    const country = metadata.countries[iso2];
    let dynamicMax = 15;
    if (country && country[3]) {
        dynamicMax = Math.max(...country[3]);
    }

    // Remove everything except digits
    const digitsOnly = value.replace(/\D/g, '');

    // Extract national number (remove dial code from beginning)
    let national = digitsOnly.slice(dialCode.length);

    // Reconstruct value with dialCode
    const finalValue = '+' + dialCode + national;

    // Update Formik state
    formik.setFieldValue(fieldName, finalValue);

    // Mark as touched
    formik.setFieldTouched(fieldName, true, true);
};
